import type { LedgerCategory, LedgerEntryType } from "@zentrani/api-client";

export const LEDGER_TYPE_LABEL: Record<LedgerEntryType, string> = {
  income: "Ingreso",
  expense: "Gasto",
};

export const INCOME_CATEGORIES: LedgerCategory[] = [
  "hoa_fees",
  "special_assessment",
  "amenities",
  "donations",
  "other",
];

export const EXPENSE_CATEGORIES: LedgerCategory[] = [
  "maintenance",
  "utilities",
  "security",
  "cleaning",
  "salaries",
  "supplies",
  "insurance",
  "legal",
  "amenities",
  "other",
];

export const LEDGER_CATEGORY_LABEL: Record<LedgerCategory, string> = {
  hoa_fees: "Cuotas",
  special_assessment: "Cuota extraordinaria",
  amenities: "Áreas comunes",
  donations: "Donaciones",
  other: "Otro",
  maintenance: "Mantenimiento",
  utilities: "Servicios",
  security: "Seguridad",
  cleaning: "Limpieza",
  salaries: "Planilla",
  supplies: "Insumos",
  insurance: "Seguros",
  legal: "Legal / admin",
};

export function ledgerCategoryLabel(category: string): string {
  return LEDGER_CATEGORY_LABEL[category as LedgerCategory] ?? category;
}

export function categoriesForType(entryType: LedgerEntryType): LedgerCategory[] {
  return entryType === "income" ? INCOME_CATEGORIES : EXPENSE_CATEGORIES;
}

export function monthInputValue(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function parseMonthInput(value: string): { year: number; month: number } | null {
  const match = /^(\d{4})-(\d{2})$/.exec(value);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) return null;
  return { year, month };
}
